import request from '@/utils/request'
import router from '@/router'

export default {
    getNews: async({ commit, dispatch }, data) => {
        await request({
            method: 'get',
            url: '/news',
            params: {
                showTo: data && data.showTo,
                ...Object.select(data, ['fromDate', 'toDate', 'page', 'header'])
            }
        }).then(res => {
            if (res.data && res.data.items) {
                commit('SET_PAGINATION', {
                    length: res.data.totalPages,
                    page: res.data.page,
                    total: res.data.total,
                    limit: res.data.limit
                })

                commit('SET_NEWS', res.data.items)
            }
        }).catch(error => {
            dispatch('addMessage', {
                type: 'error',
                message: error.response.message
            }, { root: true })
        })
    },

    getNewsById: async({ commit, dispatch }, id) => {
        return request({
            method: 'get',
            url: `news/${id}`
        }).then(res => {
            return res
        }).catch(error => {
            if (error.response && error.response.data.code === 404) {
                router.push('/news/editor'); return
            }

            dispatch('addMessage', {
                type: 'error',
                message: error.response.message
            }, { root: true })

            return error
        })
    },

    createFeed: async({ commit, dispatch }, formData) => {
        commit('SET_LOAD', true)
        return request({
            method: 'post',
            url: 'news',
            data: formData
        }).then(res => {
            if (res.data && res.data.news) {
                dispatch('addMessage', {
                    message: 'feedCreated',
                    type: 'success'
                }, { root: true })
            }

            return res
        }).catch(error => {
            dispatch('addMessage', {
                type: 'error',
                message: error.response.data.message
            }, { root: true })
        }).finally(() => {
            commit('SET_LOAD', false)
        })
    },

    updateFeed: async({ commit, dispatch }, data) => {
        commit('SET_LOAD', true)
        return request({
            method: 'put',
            url: `news/${data.get('id')}`,
            data: data
        }).then(res => {
            if (res.data) {
                commit('EDIT_NEWS', res.data)

                dispatch('addMessage', {
                    message: 'feedUpdated',
                    type: 'success'
                }, { root: true })
            }

            return res
        }).catch(error => {
            if (error && error.response) {
                dispatch('addMessage', {
                    type: 'error',
                    message: error.response.data.message,
                    locale: newsNotExist(error)
                }, { root: true })
            }

            return error
        }).finally(() => {
            commit('SET_LOAD', false)
        })
    },

    deleteFeed: async({ commit, dispatch }, feedId) => {
        await request({
            method: 'delete',
            url: 'news/' + feedId
        }).then(res => {
            if (res.status === 204) {
                dispatch('addMessage', {
                    message: 'feedDeleted',
                    type: 'success'
                }, { root: true })
            }
        }).catch(error => {
            if (error && error.response) {
                dispatch('addMessage', {
                    type: 'error',
                    message: error.response.data.message,
                    locale: newsNotExist(error)
                }, { root: true })
                commit('SET_LOAD', false)
            }
        })
    }
}

function newsNotExist(error) {
    return error.response.status === 404
}
